/**
 * How wide is each step bar
 */
export const NODE_WIDTH = 20;

/**
 * How tall is the tooltip on the steps
 */
export const NODE_TOOLTIP_HEIGHT = 65;

/*
 * In case the tooltip is expanded, how much it can grow
 */
export const EXPANDED_NODE_TOOLTIP_HEIGHT = 200;

/**
 * What is the horizontal spacing between nodes (steps)
 */
export const NODE_HORIZONTAL_SPACE = 250;
/**
 * How much space to leave between 2 nodes of a same event but in different
 * groups
 */
export const NODE_GROUP_VERTICAL_SPACE = 2;

/**
 * How many pixels correspond to 100% bar should be tall
 */
export const HUNDRED_PERCENT_SIZE = 300;
